import { render, staticRenderFns } from "./LampMtap7V1ControllerTelemetryCard.vue?vue&type=template&id=61c13c1c&scoped=true&"
import script from "./LampMtap7V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./LampMtap7V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./LampMtap7V1ControllerTelemetryCard.vue?vue&type=style&index=0&id=61c13c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c13c1c",
  null
  
)

export default component.exports